/* NIVIÈREE — Favoritos sem login (salvos no navegador do cliente).
   Qualquer botão com [data-nvr-fav="<handle>"] vira um coração que favorita o produto.
   O ícone do cabeçalho mostra a contagem; a página /pages/favorites lista os itens em [data-nvr-favorites]. */
(function () {
  var KEY = 'nvr-favorites-v1';
  var HEART = '<svg class="nvr-heart" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.2s-7.2-4.3-8.8-9C2.1 7.9 4.1 4.8 7.3 4.8c2 0 3.5 1.1 4.7 2.8 1.2-1.7 2.7-2.8 4.7-2.8 3.2 0 5.2 3.1 4.1 6.4-1.6 4.7-8.8 9-8.8 9Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle); else list.splice(i, 1);
    write(list);
    refresh();
    document.dispatchEvent(new CustomEvent('nvr:favorites-change', { detail: { handle: handle, active: i === -1, count: list.length } }));
    return i === -1;
  }

  function refresh() {
    var list = read();
    var count = list.length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-nvr-fav-link]'), function (a) {
      a.classList.toggle('is-active', count > 0);
      var bubble = a.querySelector('[data-nvr-fav-count]');
      if (bubble) {
        bubble.textContent = String(count);
        bubble.classList.toggle('opacity-0', count === 0);
      }
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-nvr-fav]'), function (btn) {
      var on = list.indexOf(btn.getAttribute('data-nvr-fav')) !== -1;
      if (btn.getAttribute('aria-pressed') !== String(on)) btn.setAttribute('aria-pressed', String(on));
      var label = on ? 'Remover dos favoritos' : 'Adicionar aos favoritos';
      if (btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-nvr-fav]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var on = toggle(btn.getAttribute('data-nvr-fav'));
    if (on) {
      btn.classList.remove('is-popping');
      void btn.offsetWidth;
      btn.classList.add('is-popping');
    }
    var page = btn.closest('[data-nvr-favorites]');
    if (page && !on) renderPage(page);
  }, true);

  window.addEventListener('storage', function (e) { if (e.key === KEY) { refresh(); renderAll(); } });

  /* ---------- favorites page ---------- */
  function money(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function imgUrl(src, width) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function renderPage(root) {
    var list = read();
    if (!list.length) {
      root.innerHTML =
        '<div class="nvr-favs__empty">' +
          '<span class="nvr-favs__empty-icon">' + HEART + '</span>' +
          '<p class="nvr-favs__empty-title">Nenhum favorito ainda</p>' +
          '<p class="nvr-favs__empty-text">Toque no coração de qualquer peça para guardá-la aqui. Fica salvo neste aparelho, sem precisar de conta.</p>' +
          '<a class="nvr-favs__empty-link" href="/collections/all">Ver todos os produtos</a>' +
        '</div>';
      return;
    }
    root.innerHTML = '<p class="nvr-favs__count">' + list.length + (list.length === 1 ? ' peça salva' : ' peças salvas') + '</p><div class="nvr-favs__grid" aria-busy="true"></div>';
    var grid = root.querySelector('.nvr-favs__grid');
    Promise.all(list.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var live = [];
      grid.innerHTML = products.map(function (p, i) {
        if (!p) return '';
        live.push(list[i]);
        var compare = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '';
        return '' +
          '<article class="nvr-favs__card">' +
            '<a class="nvr-favs__media" href="' + esc(p.url) + '">' +
              (p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 700)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
              (p.available ? '' : '<span class="nvr-favs__badge">Esgotado</span>') +
            '</a>' +
            '<button type="button" class="nvr-fav-btn nvr-fav-btn--card" data-nvr-fav="' + esc(p.handle) + '" aria-pressed="true" aria-label="Remover dos favoritos">' + HEART + '</button>' +
            '<a class="nvr-favs__info" href="' + esc(p.url) + '">' +
              '<span class="nvr-favs__title">' + esc(p.title) + '</span>' +
              '<span class="nvr-favs__price">' + compare + money(p.price) + '</span>' +
            '</a>' +
          '</article>';
      }).join('');
      grid.removeAttribute('aria-busy');
      if (live.length !== list.length) { write(live); refresh(); }
      if (!live.length) renderPage(root);
    });
  }
  function renderAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nvr-favorites]'), renderPage);
  }

  window.NivieereFavorites = { read: read, has: has, toggle: toggle, refresh: refresh, HEART: HEART };

  function boot() {
    refresh();
    renderAll();
    var observer = new MutationObserver(function (mutations) {
      var addedFavorites = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches('[data-nvr-fav]') || node.querySelector('[data-nvr-fav]'));
        });
      });
      if (addedFavorites) refresh();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

